<div class="sml-control-group search-dropdown-container" #searchDropdownContainer id="search-dropdown-menu-{{idSufix}}" (smlClickOutside)="closeDropdown()">
  <div class="tw-relative">
    <input #searchDropdownInput type="text" class="sml-control disabled:tw-text-[#828485]" [disabled]="isVolunteerActivity || disabled" 
     [(ngModel)]="searchTerm" [placeholder]="placeholder" [readonly]="readonly" (input)="onInput($event)"
      (blur)="onBlur()" (click)="showAllItems()" smlPreventLeadingSpace [ngClass]="{'sml-control-error': isInvalid,
        'tablet:!tw-h-[54px]' : isRegistrationItem
      }" />
    @if(!hideCrossButton){
      <button type="button" class="tw-absolute tw-top-0 tw-bottom-0 tw-right-2 tw-h-5 tw-w-5 tw-m-auto tw-rounded-full tw-bg-white tw-text-gray-500"
        *ngIf="(!disabled && (control.value?.length > 0 || searchTerm.length > 0)) && !isVolunteerActivity " (click)="clearSearchTerm(); $event.stopPropagation()">
        <i-icon [name]="'close'" [height]="'tw-h-5'" [width]="'tw-w-5'" class="!tw-block"></i-icon>
      </button>
    }
    @if(hideCrossButton){
       <button type="button" (click)="showAllItems()" class="tw-absolute tw-top-0 tw-bottom-0 tw-right-2 tw-h-5 tw-w-5 tw-m-auto tw-rounded-full tw-bg-white tw-text-gray-500"
        >
        <i-icon [name]="'chevron-down'" [height]="'tw-h-5'" [width]="'tw-w-5'" class="!tw-block"></i-icon>
      </button>
    }

  </div>
  <div class="search-dropdown-menu tw-opacity-0" #searchDropdownMenu *ngIf="isDropdownOpen">
    @if(filteredItems.length > 0) {
    @for (item of filteredItems; let idx = $index; track idx) {
    <div class="search-dropdown-item">
      <label class="search-dropdown-item-label">
        <input type="radio" name="dropdown-item" [value]="item.value" (change)="selectItem(item); $event.stopPropagation()" [checked]="isSelected(item)" />
        @if(!item.badge){

          <span>{{ item.label }}</span>
        }
        @if(item.iconName){
          <!-- icon Name to be rendered here  -->
           <!-- <i-icon [name]="''"></i-icon> -->
        }
        @if(item.badge){
          <div class="tw-flex tw-justify-between tw-items-center tw-w-full">
            <div class="search-template-dropdown tw-w-[80%] max-md:tw-w-[60%]">
              {{item.label}}
            </div>
          <sml-badge [type]="item.badge.type ?? 'mercury'" [label]="item.badge.label ?? ''" [showIcon]="item.badge.showIcon ?? false" [textSizeClass]="'tw-text-[10px]'"></sml-badge>
            
          </div>
         
        }
      </label>
    </div>
    }
    } @else {
      <ng-container *ngTemplateOutlet="noRecordFound"></ng-container>

    }

  </div>
</div>

<ng-template #noRecordFound>
  <div class="search-dropdown-item">
    <div *ngIf="!customEmptyState" class="tw-text-grey-950 tw-text-xs tw-font-medium tw-py-2 tw-px-4">No record found</div>
    <div *ngIf="customEmptyState" class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-p-4 tw-gap-2">
      <div>
        <i-icon [name]="'document-pen'" class="!tw-w-[25px] !tw-h-[25px]"></i-icon>
      </div>
      <div class="tw-font-medium tw-text-sm tw-text-[#000000] tw-text-center">
        No custom forms yet. Get started by creating your first one! Please save your progress and proceed to create a new form under your Manage tab.

      </div>
    </div>
  </div>
</ng-template>
